import pako from 'pako'

import { NotificationController } from 'core-components/library/popup'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import settings from 'src/config/settings'

import {
  mapBusinessPriorityFromApi,
  mapBusinessPriorityUserInfoFromApi,
  mapGeoMarketFromApi,
} from '../lib'
import { IBusinessPrioritiesFetchResult } from '../model/types'

import { IBusinessPrioritiesResponse } from './types'

export const fetchBusinessPrioritiesData = async (): Promise<IBusinessPrioritiesFetchResult> => {
  const serviceUrl = settings.httpsServices.partner360
  const url = `${serviceUrl}/api/v0/businessPriorities/businessPrioritiesGzip`
  const [accessToken] = getTokens()

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({}),
    })

    const buffer = await response.arrayBuffer()
    const jsonString = pako.ungzip(buffer, { to: 'string' })
    const result = JSON.parse(jsonString) as IBusinessPrioritiesResponse
    const records = (result.data.BusinessPriorities ?? []).map(mapBusinessPriorityFromApi)
    const userInfo = result.data.UserInfo
      ? mapBusinessPriorityUserInfoFromApi(result.data.UserInfo)
      : null
    const geoMarkets = (result.data.GeoMarkets ?? [])
      .map(mapGeoMarketFromApi)
      .sort((a, b) => a.order - b.order)

    return { records, userInfo, geoMarkets }
  } catch (e: unknown) {
    const errorMessage = e instanceof Error ? e.message : 'Failed to fetch business priorities'
    NotificationController.showError({ message: errorMessage })

    return { records: [], userInfo: null, geoMarkets: [] }
  }
}
